import Card from './Card'
import Divider from './Divider'
import ErrorMessage from './ErrorMessage'
import Header from './Header'
import Pad from './Pad'
import SavedMessage from './SavedMessage'
import Title from './Title'

Card.Divider = Divider
Card.ErrorMessage = ErrorMessage
Card.Pad = Pad
Card.Title = Title
Card.Header = Header
Card.SavedMessage = SavedMessage

export default Card



// WEBPACK FOOTER //
// ./src/components/Card/index.js